import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";
import NewLink from "../NewLink/NewLink";
import { DrawerComponent } from "../../../components/UI/Drawer/DrawerComponent";
import { useDispatch, useSelector } from "react-redux";
import { getLibraries } from "../../../slices/Admin/contolLibrary.slice";
import ControlLibraryHeader from "./ControlLibraryHeader";
import ControlLibraryBody from "./ControlLibraryBody";
import { checkIsAdmin, checkIsEmployee } from "../../../helpers/utils";

const ControlLibrary = ({ isPlatformAdminView, orgId = "" }) => {
  const [drawerVisible, setDrawerVisible] = useState();
  const dispatch = useDispatch();
  const { libraryList } = useSelector((state) => state.controlLibrary);
  const [linkToEdit, setLinkToEdit] = useState([]);
  const location = useLocation();
  const isAdminView = checkIsAdmin();

  useEffect(() => {
    populateLibraryList();
  }, [orgId]);

  const populateLibraryList = () => {
    dispatch(getLibraries(orgId));
  };

  const handleDrawerOpen = (link) => {
    setLinkToEdit(link);
    setDrawerVisible(true);
  };

  return (
    <>
      <div
        className={`control-library employee-list list-wrapper ${
          !isAdminView && "employee-library"
        }`}
        style={{ width: "100%" }}
      >
        <ControlLibraryHeader
          isAdminView={isAdminView}
          isPlatformAdminView={isPlatformAdminView}
          handleDrawerOpen={handleDrawerOpen}
        />
        <ControlLibraryBody
          isAdminView={isAdminView}
          populateLibraryList={populateLibraryList}
          setDrawerVisible={setDrawerVisible}
          handleDrawerOpen={handleDrawerOpen}
        />
      </div>
      <DrawerComponent
        content={
          <NewLink
            linkToEdit={linkToEdit}
            isEdit={Object.keys(linkToEdit).length}
            setDrawerVisible={setDrawerVisible}
            onClose={() => setDrawerVisible(false)}
            populateLibraryList={populateLibraryList}
          />
        }
        drawerVisible={drawerVisible}
        onClose={() => setDrawerVisible(false)}
      />
    </>
  );
};

export default ControlLibrary;
